import React, { Component } from "react";
import { Growl } from "primereact/growl";
import Spinner from "../../Common/Spinner";
import "react-datepicker/dist/react-datepicker.css";
import { Textbox } from "react-inputs-validation";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import axios from "axios";
import * as appConst from "../../Common/constants";

class IncomeTypeAddEdit extends Component {
  constructor(props) {
    super(props);

    var _incomeType, _mode, _hasNameError;
    if (this.props.pData._id === "NA") {
      _incomeType = "";
      _hasNameError = true;
      _mode = "add";
    } else {
      _incomeType = this.props.pData.incomeType;
      _hasNameError = false;
      _mode = "edit";
    }

    this.state = {
      incomeType: _incomeType,
      spinnerClass: "collapse",
      dataClass: "",
      validate: false,
      hasNameError: _hasNameError,
      mode: _mode
    };
  }

  render() {
    return (
      <div>
        <h5 align="center"> {this.getHeading()}</h5>
        <div className={this.state.spinnerClass}>
          <Spinner />
        </div>
        <div className={this.state.dataClass}>
          <div className="container-fluid">
            <div className="row p-1 border">
              <div className="col col-md-2">Income Type</div>
              <div className="col col-md-3">
                <Textbox
                  value={this.state.incomeType}
                  placeholder="Enter Income Type"
                  onChange={(incomeType, e) => {
                    this.setState({ incomeType });
                  }}
                  onBlur={e => {}}
                  validationOption={{
                    name: "Income Type",
                    check: true,
                    required: true
                  }}
                  validate={this.state.validate}
                  validationCallback={res =>
                    this.setState({ hasNameError: res, validate: false })
                  }
                />
              </div>
            </div>
            <div className="row p-1 border">
              <button
                onClick={this.onSaveClick}
                className="btn btn-primary btn-md mr-2"
              >
                Save
              </button>
              <button
                onClick={this.onClearClick}
                className="btn btn-primary btn-md mr-2"
              >
                Clear
              </button>
              <button
                onClick={this.onCancelClick}
                className="btn btn-primary btn-md mr-2"
              >
                Cancel
              </button>
            </div>
            <Growl ref={el => (this.growl = el)} />
          </div>
        </div>
      </div>
    );
  }

  getHeading() {
    if (typeof this.state._id === "undefined" || this.state._id === "") {
      return "Add New IncomeType";
    } else {
      return "Edit IncomeType " + this.state.incomeType;
    }
  }

  onSaveClick = async e => {
    e.preventDefault();
    this.toggleValidating(true);

    if (!this.state.hasNameError) {
      const obj = {
        incomeType: this.state.incomeType
      };
      if (this.state.mode === "add") {
        axios
          .post(
            (process.env.NODE_ENV !== "development"
              ? appConst.API_URL_PROD
              : appConst.API_URL_DEV) +
              
              "/IncomeType/add",
            obj
          )
          .then(res => console.log(res.data));
        this.toggleValidating(false);
        this.setState({ hasNameError: true });
        this.ClearData();
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "IncomeType Added !!!"
        });
      } else {
        axios
          .post(
            (process.env.NODE_ENV !== "development"
              ? appConst.API_URL_PROD
              : appConst.API_URL_DEV) +
              
              "/IncomeType/update/" +
              this.props.pData._id,
            obj
          )
          .then(res => {
            this.growl.show({
              severity: "success",
              summary: "Success",
              detail: "IncomeType Updated !!!"
            });
            this.props.onClick("List", null);
          });
      }
    }
  };

  toggleValidating(validate) {
    this.setState({ validate });
  }

  ClearData() {
    this.setState({ incomeType: "", hasNameError: true });
  }

  onClearClick = e => {
    this.ClearData();
    this.growl.show({
      severity: "success",
      summary: "Success",
      detail: "Data Cleared !!!"
    });
  };

  onCancelClick = e => {
    this.props.onClick("List", null);
  };
}

export default IncomeTypeAddEdit;
